import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataManipulateService {

  Token:string = '';
  userInfo:any={};


  constructor() { }
}
